module.exports = __webpack_public_path__ + "img/ico_payment_off.3216fa72.svg";